import { ErrorAsValue } from '@/services/api/base-api.ts';

export class ApiFlexError extends Error {
  value: ErrorAsValue;

  constructor(error: ErrorAsValue) {
    super(error.message);
    this.value = error;
  }
}
